import { MainLayout } from '@/widgets/layouts/main';
import { Article } from '@/shared/components/article';
import { PageSeo } from '@/shared/lib/seo';
import { APP_TITLE } from '@/shared/lib/seo/meta';
export const PaymentRulesPage = () => {
  return <>
      <PageSeo title="Правила оплаты" description={`Положения о правилах оплаты услуг. ${APP_TITLE} – деловой английский для работы.`} noindex />

      <Article tag="main" className="select-none">
        <h1 className="mb-20 text-center header-h1">Правила оплаты</h1>

        <section className="mx-auto mb-10 max-w-6xl space-y-2">
          <p>К оплате принимаются платежные карты: VISA Inc, MasterCard WorldWide, МИР.</p>

          <h2 className="mb-4 header-h3">
            При оплате заказа банковской картой, обработка платежа происходит на авторизационной странице банка, где Вам
            необходимо ввести данные Вашей банковской карты:
          </h2>

          <ul className="list-inside list-disc">
            <li>Тип карты</li>
            <li>Номер карты</li>
            <li>Срок действия карты (указан на лицевой стороне карты)</li>
            <li>Имя держателя карты (латинскими буквами, точно также как указано на карте)</li>
            <li>CVC2/CVV2 код</li>
          </ul>

          <p>
            Если ваша карта подключена к услуге 3D-Secure, Вы будете автоматически переадресованы на страницу банка,
            выпустившего карту, для прохождения процедуры аутентификации. Информацию о правилах и методах дополнительной
            идентификации уточняйте в Банке, выдавшем вам банковскую карту.
          </p>

          <p>
            Безопасность обработки интернет-платежей через платежный шлюз банка гарантирована международным сертификатом
            безопасности PCI DSS. Передача информации происходит с применением технологии шифрования TLS. Эта информация
            недоступна посторонним лицам.
          </p>
        </section>

        <section className="mx-auto mb-10 max-w-6xl space-y-2">
          <h2 className="mb-4 header-h3">
            Советы и рекомендации по необходимым мерам безопасности проведения платежей с использованием банковской
            карты:
          </h2>

          <ul className="list-inside list-disc">
            <li>
              Берегите свои пластиковые карты так же, как бережете наличные деньги. Не забывайте их в машине, ресторане,
              магазине и т.д.
            </li>

            <li>
              Никогда не передавайте полный номер своей кредитной карты по телефону каким-либо лицам или компаниям
            </li>

            <li>
              Всегда имейте под рукой номер телефона для экстренной связи с банком, выпустившим вашу карту, и в случае
              ее утраты немедленно свяжитесь с банком
            </li>

            <li>
              Вводите реквизиты карты только при совершении покупки. Никогда не указывайте их по каким-то другим
              причинам.
            </li>
          </ul>
        </section>

        <section className="mx-auto mb-10 max-w-6xl">
          <h2 className="mb-4 header-h3">Отказ от услуги</h2>

          <p>
            Право потребителя на расторжение договора об оказании услуги регламентируется статьей 32 федерального закона
            «О защите прав потребителей»
          </p>

          <ul className="list-inside list-disc">
            <li>
              Потребитель вправе расторгнуть договор об оказании услуги в любое время, уплатив исполнителю часть цены
              пропорционально части оказанной услуги до получения извещения о расторжении указанного договора и
              возместив исполнителю расходы, произведенные им до этого момента в целях исполнения договора, если они не
              входят в указанную часть цены услуги;
            </li>

            <li>Потребитель при обнаружении недостатков оказанной услуги вправе по своему выбору потребовать:</li>

            <ul className="list-inside list-disc">
              <li>безвозмездного устранения недостатков;</li>
              <li>соответствующего уменьшения цены;</li>
              <li>возмещения понесенных им расходов по устранению недостатков своими силами или третьими лицами;</li>
            </ul>

            <li>
              Потребитель вправе предъявлять требования, связанные с недостатками оказанной услуги, если они обнаружены
              в течение срока действия услуги;
            </li>

            <li>
              Исполнитель отвечает за недостатки услуги, на которую не установлен гарантийный срок, если потребитель
              докажет, что они возникли до ее принятия им или по причинам, возникшим до этого момента;
            </li>
          </ul>
        </section>

        <section className="mx-auto mb-10 max-w-6xl">
          <h2 className="mb-4 header-h3">8. Сведения об Исполнителе:</h2>

          <div className="text-muted-foreground/80">
            <p>Название компании: ИП Сладких Анна Святославовна</p>
            <p>Режим работы: Пн.-Пт. 9:00 - 18:00</p>
            <p>Почтовый адрес: 454080 г.Челябинск, пр. Ленина 77-28</p>
            <p>Юридический адрес: 454080 г.Челябинск, пр. Ленина 77-28</p>
            <p>Телефон: +79512418196</p>
            <p>E-mail: {process.env.NEXT_PUBLIC_EMAIL_URL ?? ''}</p>

            <p>р/с №: 40802810701500513350</p>
            <p>БИК: 044525104</p>
            <p>Банк: ООО &ldquo;Банк Точка&rdquo;</p>

            <p>ИНН: 745312661384</p>
            <p>ОГРНИП: 323745600057252</p>
          </div>
        </section>
      </Article>
    </>;
};
PaymentRulesPage.Layout = MainLayout;